import React, {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {HtmlText} from '@shared/ui/HTMLText';
import {Icon} from '@shared/ui/Icon';

import {ValidationIconWrapper, ValidationItem, ValidationList} from '../styled'; // Путь к вашим стилям

interface Props {
    watchValue: string;
}

export const PasswordValidationRules = ({watchValue}: Props) => {
    const {t} = useTranslation();

    const rules = useMemo(
        () => [
            {
                key: 'length',
                label: t('password.rules.length'),
                isValid: watchValue.length >= 8 && watchValue.length <= 20,
            },
            {
                key: 'digit',
                label: t('password.rules.digit'),
                isValid: /\d/.test(watchValue),
            },
            {
                key: 'alphabet',
                label: t('password.rules.alphabet'),
                isValid: /[A-Za-z]/.test(watchValue),
            },
            {
                key: 'specialSymbol',
                label: t('password.rules.specialSymbol'),
                isValid: /[@$!%*#?&]/.test(watchValue),
            },
        ],
        [watchValue, t],
    );

    return (
        <ValidationList>
            {rules.map((rule) => (
                <ValidationItem key={rule.key}>
                    <ValidationIconWrapper isValid={rule.isValid}>
                        {rule.isValid ? <Icon name="check" width={20} height={20} /> : '•'}
                    </ValidationIconWrapper>
                    <HtmlText __html={rule.label} />
                </ValidationItem>
            ))}
        </ValidationList>
    );
};
